import { autoinject, transient } from 'aurelia-dependency-injection';
import { AttachmentFile, AttachmentTypeModel } from '../../models/attachments.models';
import { EntityTypes } from '../../models/basic.models';
import { bindable } from 'aurelia-templating';
import { BindingSignaler } from 'aurelia-templating-resources';

require("./partial-upload-psc-files.scss");

@autoinject()
@transient()
export class PartialUploadPscFiles {

    @bindable
    public showInDialog: boolean = true;

    @bindable
    public attachmentTypes: AttachmentTypeModel[] = [];

    public entityTypeId: number = EntityTypes.PSC;
    public files: AttachmentFile[];
    public capRcaFile: AttachmentFile[];
    public aBFormsFiles = [[], []]; //2 empty files for A/B Forms
    public otherAttachment = [[]];
    public abAttachmentTypes: any = {};
    public otherAttachmentTypes = [[]];
    public disabledAttachments: any = {};

    constructor(private bindingSignaler: BindingSignaler) {}

    attached() {
        this.abAttachmentTypes[0] = this.abAttachmentTypes[1] = this.attachmentTypes.filter(x => x.internalName === 'initial-psc-report-form-a' || x.internalName === 'initial-psc-report-form-b' || x.internalName === 'initial-psc-report-form-ab');
        this.otherAttachmentTypes[0] = this.attachmentTypes.filter(x => x.internalName !== 'initial-psc-report-form-a' && x.internalName !== 'initial-psc-report-form-b' && x.internalName !== 'initial-psc-report-form-ab');
        this.disabledAttachments[0] = this.disabledAttachments[1] = false;
    }

    removeFile(file: AttachmentFile[]) {

        //Always remove 1st file since each file-uploader only have 1 file
        file.splice(0, 1);
        
        //Signal to refresh attachment types
        this.bindingSignaler.signal('removed-file');
    }

    addOtherAttachments() {
        this.otherAttachment.push([]);
        this.reFilterOtherAttachmentTypes();
    }

    removeOtherAttachment($index) {
        this.otherAttachment.splice($index, 1);
        this.otherAttachmentTypes.splice($index, 1);
        this.reFilterOtherAttachmentTypes();
    }

    reFilterOtherAttachmentTypes() {
        Object.keys(this.otherAttachment).forEach(key => {
            const hiddenItems = this.otherAttachment.map((x, i) => {
                if (Number(key) != i)
                return x[0]?.internalName;
            });
            
            //Filter out form A/B and already selected attachment type
            this.otherAttachmentTypes[Number(key)] = this.attachmentTypes.filter(x => x.internalName !== 'initial-psc-report-form-a' && x.internalName !== 'initial-psc-report-form-b' && x.internalName !== 'initial-psc-report-form-ab' && !hiddenItems.includes(x.internalName));
        });
    }

    //Merge all files into 1 array
    mergePscFiles() {
        this.files = [];
        
        //Add close-out CAP/RCA file
        if(this.capRcaFile && this.capRcaFile[0]){
            this.capRcaFile[0].attachmentTypeId = this.attachmentTypes.find(x => x.internalName === 'close-out-cap-rca').attachmentTypeId;
            this.files.push(this.capRcaFile[0])
        }

        //Add A/B Forms files
        this.aBFormsFiles.forEach((file) => {
            if(file && file[0]){
                this.files.push(file[0]);
            }
        });

        //Other attachments
        this.otherAttachment.forEach((file) => {
            if(file && file[0]){
                this.files.push(file[0]);
            }
        });
    }

    attachmentTypeChanged(internalName, index, isAbForm) {
        if (isAbForm) {

            const files = [];
            this.aBFormsFiles.forEach((file) => {
                file[0] ? files.push(file[0].internalName): null;
            });

            this.setValue(this.aBFormsFiles[index][0]);

            Object.keys(this.abAttachmentTypes).forEach(key => {
                if(files.length > 0){

                    if (index != key){
                        this.abAttachmentTypes[Number(key)] = this.attachmentTypes.filter(x => ( x.internalName === 'initial-psc-report-form-a' || x.internalName === 'initial-psc-report-form-b'
                            || (internalName === 'initial-psc-report-form-ab' ? x.internalName === 'initial-psc-report-form-ab' : false)) && x.internalName != internalName)
                    }
                } else {

                    //Reset default attachment types if no files are uploaded
                    this.abAttachmentTypes[Number(key)] = this.attachmentTypes.filter(x => x.internalName === 'initial-psc-report-form-a' || x.internalName === 'initial-psc-report-form-b' || x.internalName === 'initial-psc-report-form-ab')
                }
            });

            Object.keys(this.disabledAttachments).forEach(key => {
                this.disabledAttachments[Number(key)] = internalName === 'initial-psc-report-form-ab' ? this.aBFormsFiles[Number(key)][0]?.internalName !== 'initial-psc-report-form-ab' : false;
                
                if (this.disabledAttachments[Number(key)]) 
                    this.aBFormsFiles[Number(key)] = [];
            });
        } else {
            this.setValue(this.otherAttachment[index][0]);
            this.reFilterOtherAttachmentTypes();
        }
    }

    setValue(file) {
        file.attachmentTypeId = file.attachmentType.attachmentTypeId;
        file.entityTypeId = file.attachmentType.entityTypeId;
        file.internalName = file.attachmentType.internalName;
        !file.name ? file.name = file.attachmentType.name : null;
    }
}